function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#C5101C",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M11.69 4h.757c1.96.112 3.882.943 5.258 2.357a7.943 7.943 0 0 1 1.179 9.637 7.936 7.936 0 0 1-9.526 3.41 7.927 7.927 0 0 1-4.205-3.571c-.868-1.501-1.19-3.3-.955-5.024.273-1.972 1.34-3.82 2.903-5.073C8.39 4.695 10.028 4.086 11.69 4zm-.521 1.29c-2.12.26-4.056 1.625-5.048 3.522a6.696 6.696 0 0 0-.533 4.887 6.78 6.78 0 0 0 2.989 3.97 6.688 6.688 0 0 0 4.564.88c1.898-.285 3.622-1.451 4.626-3.076a6.738 6.738 0 0 0 .93-4.527 6.68 6.68 0 0 0-2.629-4.379A6.676 6.676 0 0 0 11.17 5.29zm-3.361 6.04h2.43v1.216h-2.43v3.671h3.969V14.99H9.036v-1.228h2.43v-3.659h-2.43V8.887h2.74V7.659H7.809v3.671zm4.576-3.659v1.216h2.742v1.228h-2.431v3.671h2.43v1.216h-2.74v1.227h3.956v-3.658h-2.43v-1.228h2.43v-3.66c-1.315-.012-2.642-.012-3.957-.012z"
}));

var SvgIcIcbc = function SvgIcIcbc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcIcbc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_icbc.fa416416.svg";
export { ForwardRef as ReactComponent };